// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_UNPREPARED_TAG = "Pripravujeme";
